
function lnglatAlarm(type,id,marker1){

  setTimeout(function(){
    var map = new AMap.Map(`${id.id}`, {
      zoom: 16,
      pitch: 25,
      viewMode: '3D',
      resizeEnable: true,
      rotateEnable:false,
      pitchEnable:false,
      layers: [new AMap.TileLayer.Satellite()],
    })

    let centralPoint;
    if(!marker1 || !marker1.lng || !marker1.lat){
      centralPoint = [{lng:'116.39732',lat:'39.909184',name:'未找到设备经纬度位置！'}];
    }else{
      centralPoint = [{lng:marker1.lng,lat:marker1.lat,name:''}];
    }
    centralPoint.forEach(item=>{
      if(!item.lng || !item.lat){return};
      let marker = new AMap.Marker({
        map:map,
        position:[item.lng,item.lat],
        content: `<div class="dianAnimat" style="background-color: rgba(255, 43, 15, 1.0); height: 15px; width: 15px; border: 1px solid rgba(255, 43, 15, 0); border-radius: 15px; box-shadow: rgba(255, 43, 15, 0) 0px 0px 1px;"></div>`, //设置文本标注内容
				offset: new AMap.Pixel(-7, -7) 
      });
			
      // marker.setLabel({
      //   offset: new AMap.Pixel(0, 0),  //设置文本标注偏移量
      //   direction: 'bottom' //设置文本标注方位
      // });

      map.setCenter([item.lng,item.lat]);
    })
  })
}

export{
  lnglatAlarm
}


// WEBPACK FOOTER //
// ./src/js/lnglatAlarm.js